import { render, staticRenderFns } from "./MyVideoPlayer.vue?vue&type=template&id=a0198d10&scoped=true&"
import script from "./MyVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./MyVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MyVideoPlayer.vue?vue&type=style&index=0&id=a0198d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0198d10",
  null
  
)

export default component.exports